import { render, staticRenderFns } from "./FrequencyDocumentEdit.vue?vue&type=template&id=2b74278e"
import script from "./FrequencyDocumentEdit.vue?vue&type=script&lang=ts"
export * from "./FrequencyDocumentEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b74278e')) {
      api.createRecord('2b74278e', component.options)
    } else {
      api.reload('2b74278e', component.options)
    }
    module.hot.accept("./FrequencyDocumentEdit.vue?vue&type=template&id=2b74278e", function () {
      api.rerender('2b74278e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencyDocumentEdit.vue"
export default component.exports